(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bcf-works-production"]) return;
  try {
    
(() => {
  const root = document.querySelector('.bcf');
  const dialog = document.querySelector('#bcf-image-viewer');
  if (!root || !dialog || root.dataset.viewerReady) return;
  root.dataset.viewerReady = 'true';
  const image = dialog.querySelector('.bcf-viewer-image');
  const protectImage = event => {
    if (event.target.closest('button[data-bcf-image], .bcf-viewer-image, .bcf-portrait')) event.preventDefault();
  };
  for (const surface of [root, dialog]) {
    surface.addEventListener('contextmenu', protectImage);
    surface.addEventListener('dragstart', protectImage);
  }
  root.querySelectorAll('button[data-bcf-image] img').forEach(img => img.draggable = false);
  image.draggable = false;
  let opener;
  root.addEventListener('click', event => {
    const button = event.target.closest('button[data-bcf-image]');
    if (!button || !root.contains(button)) return;
    opener = button;
    const work = button.closest('.bcf-work');
    dialog.querySelector('#bcf-viewer-title').textContent = work.querySelector('h3').textContent;
    dialog.querySelector('.bcf-viewer-artist').textContent = work.querySelector('.bcf-artist').textContent;
    image.alt = button.querySelector('img').alt;
    image.src = button.dataset.bcfImage;
    dialog.showModal();
  });
  dialog.querySelector('.bcf-viewer-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    image.removeAttribute('src');
    if (opener && opener.isConnected) opener.focus({preventScroll:true});
  });
  if (!('closedBy' in HTMLDialogElement.prototype)) {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bcf-works"]) return;
  try {
    
(() => {
  const root = document.querySelector('.bcf');
  const dialog = document.querySelector('#bcf-image-viewer');
  if (!root || !dialog || root.dataset.viewerReady) return;
  root.dataset.viewerReady = 'true';
  const image = dialog.querySelector('.bcf-viewer-image');
  const protectImage = event => {
    if (event.target.closest('button[data-bcf-image], .bcf-viewer-image, .bcf-portrait')) event.preventDefault();
  };
  for (const surface of [root, dialog]) {
    surface.addEventListener('contextmenu', protectImage);
    surface.addEventListener('dragstart', protectImage);
  }
  root.querySelectorAll('button[data-bcf-image] img').forEach(img => img.draggable = false);
  image.draggable = false;
  let opener;
  root.addEventListener('click', event => {
    const button = event.target.closest('button[data-bcf-image]');
    if (!button || !root.contains(button)) return;
    opener = button;
    const work = button.closest('.bcf-work');
    dialog.querySelector('#bcf-viewer-title').textContent = work.querySelector('h3').textContent;
    dialog.querySelector('.bcf-viewer-artist').textContent = work.querySelector('.bcf-artist').textContent;
    image.alt = button.querySelector('img').alt;
    image.src = button.dataset.bcfImage;
    dialog.showModal();
  });
  dialog.querySelector('.bcf-viewer-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    image.removeAttribute('src');
    if (opener && opener.isConnected) opener.focus({preventScroll:true});
  });
  if (!('closedBy' in HTMLDialogElement.prototype)) {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function scrollToNewsletter() {
      let target;
      try {
        target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
      } catch {
        return;
      }
      if (!target || !target.querySelector('[data-newsletter-anchor]')) return;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          target.scrollIntoView({ behavior: 'instant', block: 'start' });
        });
      });
    }
    if (document.readyState === 'complete') scrollToNewsletter();
    else window.addEventListener('load', scrollToNewsletter, { once: true });
    window.addEventListener('hashchange', scrollToNewsletter);
  })();

  } catch(e) { console.error(e); }
})();
})();
